import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

/** Read-only value with a copy-to-clipboard button (for one-time links). */
export function CopyField({ value, label }: { value: string; label: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // Clipboard API unavailable (e.g. plain HTTP on a LAN address): select the text instead.
      const input = document.getElementById("copy-field-value") as HTMLInputElement | null;
      input?.select();
      document.execCommand?.("copy");
    }
    setCopied(true);
  }

  return (
    <div className="flex gap-2">
      <Input
        id="copy-field-value"
        readOnly
        value={value}
        aria-label={label}
        onFocus={(event) => event.currentTarget.select()}
        className="font-mono text-xs"
      />
      <Button type="button" variant="outline" onClick={copy} className="shrink-0">
        {copied ? <Check aria-hidden /> : <Copy aria-hidden />}
        {copied ? t("actions.copied") : t("actions.copy")}
      </Button>
    </div>
  );
}
